import { render, staticRenderFns } from "./patientMainPage.vue?vue&type=template&id=ad44a296&scoped=true"
import script from "./patientMainPage.vue?vue&type=script&lang=js"
export * from "./patientMainPage.vue?vue&type=script&lang=js"
import style0 from "./patientMainPage.vue?vue&type=style&index=0&id=ad44a296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad44a296",
  null
  
)

export default component.exports